import { render, staticRenderFns } from "./RbButton.vue?vue&type=template&id=e458bf90&scoped=true"
import script from "./RbButton.vue?vue&type=script&lang=js"
export * from "./RbButton.vue?vue&type=script&lang=js"
import style0 from "./RbButton.vue?vue&type=style&index=0&id=e458bf90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458bf90",
  null
  
)

export default component.exports